import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PaymentSection from '../PaymentSection/PaymentSection';
import InstructionsTab from '../InstructionsTab/InstructionsTab';
import ColorThemes from '../ColorThemes/ColorThemes';
import { getPaymentMode, isWatchfaceProduct } from '../../utils/productType';
import { getCustomTabsForProduct } from '../customTabs';
import ScrollSpyTabs from '../ScrollSpyTabs/ScrollSpyTabs';
import './DetailTabs.css';
const DetailTabs = ({ product, colorThemes }) => {
    const { t, i18n } = useTranslation();
    const customTabDefs = useMemo(() => getCustomTabsForProduct(product), [product]);
    const paymentMode = getPaymentMode(product.is_vx);
    const isFreeProduct = paymentMode === 4;
    const isWatchface = isWatchfaceProduct(product.is_vx);
    const allTabs = useMemo(() => {
        const standardTabs = [
            ...(isWatchface ? [{ id: 'instructions', label: t('detailTabs.instructions', 'Instructions'), icon: '📖', order: 1 }] : []),
            ...(!isFreeProduct ? [{ id: 'payment', label: t('detailTabs.payment', 'Payment'), icon: '💳', order: 2 }] : []),
            ...(isWatchface ? [{ id: 'themes', label: t('detailTabs.themes', 'Themes'), icon: '🎨', order: 100 }] : []),
        ];
        const custom = customTabDefs.map(def => ({
            id: def.id,
            label: def.label[i18n.language] || def.label['en'] || def.id,
            icon: def.icon,
            order: def.order,
            isCustom: true,
            customDef: def,
        }));
        return [...standardTabs, ...custom].sort((a, b) => a.order - b.order);
    }, [t, i18n.language, customTabDefs, isFreeProduct, isWatchface]);
    const renderSectionContent = (tab) => {
        if (tab.isCustom && tab.customDef) {
            const Component = tab.customDef.component;
            return _jsx(Component, { product: product });
        }
        switch (tab.id) {
            case 'payment':
                return _jsx(PaymentSection, { product: product });
            case 'themes':
                return colorThemes.length > 0 ? (_jsx(ColorThemes, { themes: colorThemes, productId: product.id })) : (_jsx("div", { className: "empty-state", children: _jsx("p", { children: t('detailTabs.noThemes', 'No color themes available for this watchface.') }) }));
            case 'instructions':
                return _jsx(InstructionsTab, {});
            default:
                return null;
        }
    };
    const sections = allTabs.map(({ id, label, icon }) => ({ id, label, icon }));
    return (_jsx(ScrollSpyTabs, { sections: sections, children: (registerRef) => allTabs.map((tab) => (_jsx("div", { id: `section-${tab.id}`, ref: registerRef(tab.id), className: "content-section", children: renderSectionContent(tab) }, tab.id))) }));
};
export default DetailTabs;
